export const DEMO_ROLE_IDS = new Set([3, 4]);

export const emptyPalmaresForm = {
  titre: "",
  resultats: "",
  date_palmares: "",
  is_active: true,
};

export function getStoredUser() {
  try {
    return JSON.parse(localStorage.getItem("user") || "null");
  } catch {
    return null;
  }
}

export function isDemoMode() {
  const user = getStoredUser();
  return DEMO_ROLE_IDS.has(Number(user?.role_id));
}

export function getFallbackSectionId(sectionId) {
  if (sectionId) return Number(sectionId);

  const user = getStoredUser();

  return user?.section_id ? Number(user.section_id) : null;
}

export function normalizeText(value = "") {
  return String(value)
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
}

export function toDateInputValue(value) {
  if (!value) return "";

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) {
    return String(value).slice(0, 10);
  }

  return date.toISOString().slice(0, 10);
}

export function formatDate(value) {
  if (!value) return "—";

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) return "—";

  return date.toLocaleDateString("fr-FR", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });
}

export function getYear(value) {
  if (!value) return null;

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) return null;

  return date.getFullYear();
}

export function truncateText(value = "", max = 150) {
  const clean = String(value || "").replace(/\s+/g, " ").trim();

  if (clean.length <= max) return clean;

  return `${clean.slice(0, max).trim()}...`;
}

export function mapPalmaresToForm(palmares) {
  return {
    titre: palmares?.titre || "",
    resultats: palmares?.resultats || "",
    date_palmares: toDateInputValue(palmares?.date_palmares),
    is_active:
      typeof palmares?.is_active === "boolean" ? palmares.is_active : true,
  };
}

export function buildPalmaresPayload(formData, sectionId) {
  return {
    titre: formData.titre,
    resultats: formData.resultats,
    date_palmares: formData.date_palmares,
    is_active: Boolean(formData.is_active),
    section_id: Number(sectionId),
  };
}

export function sortPalmares(list = []) {
  return [...list].sort((a, b) => {
    const da = new Date(a?.date_palmares || 0).getTime();
    const db = new Date(b?.date_palmares || 0).getTime();

    return db - da;
  });
}

export function filterPalmares(
  list = [],
  searchTerm = "",
  yearFilter = "all",
  statusFilter = "all"
) {
  const q = normalizeText(searchTerm.trim());

  return list.filter((item) => {
    const active = item?.is_active !== false;
    const itemYear = getYear(item?.date_palmares);

    const matchesSearch =
      !q ||
      normalizeText(
        [item?.titre, item?.resultats, item?.section?.nom_section]
          .filter(Boolean)
          .join(" ")
      ).includes(q);

    const matchesYear =
      yearFilter === "all" || String(itemYear) === String(yearFilter);

    const matchesStatus =
      statusFilter === "all" ||
      (statusFilter === "active" && active) ||
      (statusFilter === "inactive" && !active);

    return matchesSearch && matchesYear && matchesStatus;
  });
}

export function getAvailableYears(list = []) {
  const years = list
    .map((item) => getYear(item?.date_palmares))
    .filter(Boolean);

  return [...new Set(years)].sort((a, b) => b - a);
}

export function getPalmaresStats(list = []) {
  const total = list.length;
  const active = list.filter((item) => item?.is_active !== false).length;
  const inactive = total - active;

  const currentYear = new Date().getFullYear();
  const currentYearCount = list.filter(
    (item) => getYear(item?.date_palmares) === currentYear
  ).length;

  const latest = sortPalmares(list)[0];

  return {
    total,
    active,
    inactive,
    currentYearCount,
    latestTitle: latest?.titre || "—",
  };
}